module.exports = __webpack_public_path__ + "files/787db8d8b82538cc1d5e8bcb8c21722d.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-57x57.png
// module id = 1960
// module chunks = 60